import { render, staticRenderFns } from "./PartCategoryDetailCard.vue?vue&type=template&id=4e2dcbf0&scoped=true"
import script from "./PartCategoryDetailCard.vue?vue&type=script&lang=ts"
export * from "./PartCategoryDetailCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2dcbf0",
  null
  
)

export default component.exports